/*
작성일자: 2020-02-26
작성자: 김진희

파일 설명
1. CctvPopup.vue에서 분할한 파일
2. 연결, 연결해제, 연결된 CCTV 보여주는 기능이 있음
3. 연결된 CCTV 보여주는 기능은 CctvPopup.vue에서 옮겨온 기능으로,
   여기에는 그 기능에 스트리밍 로드 실패 시 3초 주기로 재시도 (retryTime = 3)

*/

import { streamEvent } from '@/api/master/master'
import envs from '@/envs'
import videojs from 'video.js'

let firstRetry = true
export var cctvInfo
let siteId = ''
let count = 0

export function connect(cctvId) {
  return _connect(cctvId)
}

// 모바일, PC 공통 적용을 위해 파라미터를 받음
export function connectAll(siteIdParam, countParam) {
  // 전역변수는 window.으로 접근
  siteId = siteIdParam
  count = countParam
  // 커넥트
  for (let i = 0; i < count; i++) {
    let cctvId = siteId + '_' + (i + 1)
    _connect(cctvId)
  }
}

function _connect(cctvId) {
  return streamEvent(
    {},
    'PUT',
    '/streamfiles/' +
      cctvId +
      '/actions/connect?connectAppName=live&appInstance=_definst_&mediaCasterType=rtp'
  )
}

export function disconnect(cctvId) {
  return _disconnect(cctvId)
}

export function disconnectAll(siteIdParam = siteId, countParam = count) {
  // console.log('in disconnectAll')
  // 비활성화 및 삭제
  for (let i = 0; i < countParam; i++) {
    let cctvId = siteIdParam + '_' + (i + 1)
    _disconnect(cctvId)
  }
}

function _disconnect(cctvId) {
  return streamEvent(
    {},
    'PUT',
    '/instances/_definst_/incomingstreams/' +
      cctvId +
      '.stream/actions/disconnectStream'
  ).catch(() => {})
}

export function captureFrameFromHLS(cctvId) {
  return new Promise((resolve) => {
    const hlsUrl = envs.WowzaAddress + '/live/' + cctvId + '.stream/playlist.m3u8'
    const playerId = 'thumb_' + cctvId.replace(/\W+/g, '_') + '_' + Date.now()

    const wrapper = document.createElement('div')
    wrapper.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:320px;height:240px'
    const videoEl = document.createElement('video')
    videoEl.id = playerId
    videoEl.setAttribute('playsinline', '')
    videoEl.setAttribute('crossorigin', 'anonymous')
    videoEl.muted = true
    wrapper.appendChild(videoEl)
    document.body.appendChild(wrapper)

    let vjs = null
    let settled = false

    function cleanup(dataUrl) {
      if (settled) return
      settled = true
      try { if (vjs) vjs.dispose() } catch (e) {}
      if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper)
      resolve(dataUrl)
    }

    const timer = setTimeout(() => cleanup(null), 15000)

    try {
      vjs = videojs(playerId, {
        autoplay: true,
        muted: true,
        controls: false,
        preload: 'auto',
        playsinline: true,
        sources: [{ src: hlsUrl, type: 'application/x-mpegURL' }]
      })

      vjs.one('loadeddata', function () {
        clearTimeout(timer)
        try {
          const techEl = this.el().querySelector('video')
          if (!techEl || !techEl.videoWidth) { cleanup(null); return }
          const canvas = document.createElement('canvas')
          canvas.width = techEl.videoWidth
          canvas.height = techEl.videoHeight
          canvas.getContext('2d').drawImage(techEl, 0, 0)
          cleanup(canvas.toDataURL('image/jpeg', 0.7))
        } catch (e) {
          cleanup(null)
        }
      })

      vjs.one('error', function () { clearTimeout(timer); cleanup(null) })
    } catch (e) {
      clearTimeout(timer)
      cleanup(null)
    }
  })
}
